export enum organizationConstants {
  GET_ORGANIZATIONS = 'GET_ORGANIZATIONS',
  GET_ORGANIZATION = 'GET_ORGANIZATION',
  ADD_ORGANIZATION = 'ADD_ORGANIZATION',
  EDIT_ORGANIZATION = 'EDIT_ORGANIZATION',
  DELETE_ORGANIZATION = 'DELETE_ORGANIZATION',
}
